import { get, groupBy, isEmpty, take } from "lodash";
import { MdOpenInNew } from "react-icons/md";
import Input from "shared/components/Input";
import { COLORS } from "shared/style/colors";
import { isLumineisUpsells } from "utils/helpers/lumineisUpsells";

const UPSELL_WEIGHT = 1;
const PACK_WEIGHT = 2;

const UPSELL_GROUPS = [
  {
    weight: UPSELL_WEIGHT,
    titleKey: "GROUP_OPTION",
    fallbackTitle: "Option complémentaire",
  },
  {
    weight: PACK_WEIGHT,
    titleKey: "GROUP_PACK",
    fallbackTitle: "Pack",
  },
];

const Card = ({
  products,
  onCheck,
  selectedModules,
  onOpenDetails,
  onShowMore,
  mainProduct,
  translation,
  disabled,
}) => {
  if (isEmpty(products))
    return (
      <div className="upsells">{get(translation, "UPSELLS.NO_MODULE", "")}</div>
    );

  const productsByWeight = groupBy(products, (product) =>
    get(product, "weight"),
  );
  const groups = UPSELL_GROUPS.map((group) => ({
    ...group,
    title: get(translation, `UPSELLS.${group.titleKey}`, group.fallbackTitle),
    items: get(productsByWeight, String(group.weight), []),
  })).filter(({ items }) => !isEmpty(items));

  const packProducts = get(productsByWeight, String(PACK_WEIGHT), []);
  const showPackDiscountNote =
    isLumineisUpsells(packProducts) && packProducts.length >= 2;

  const renderProduct = (product, index) => (
    <div className="upsells__checkbox" key={`product-${index}`}>
      <div className="upsells__checkbox--content">
        <Input
          type="checkbox"
          label={get(product, "insurancePlan.name", "")}
          onChange={() => onCheck(product)}
          id={mainProduct + product.id}
          checked={
            get(selectedModules, mainProduct, []).find(
              ({ insurancePlan }) =>
                insurancePlan?.id === get(product, "insurancePlan.id", ""),
            ) || false
          }
          disabled={disabled}
        />
      </div>
      <div
        className="upsells__checkbox--button"
        onClick={() => onOpenDetails(get(product, "insurancePlan.id"))}
      >
        <MdOpenInNew size={16} color={COLORS.C_PRIMARY} />
      </div>
    </div>
  );

  return (
    <div className="upsells">
      {showPackDiscountNote && (
        <div className="upsells__discount-note">
          {get(
            translation,
            "UPSELLS.PACK_DISCOUNT",
            "Réduction pack en cas de souscription des 2 packs",
          )}
        </div>
      )}
      {groups.map(({ weight, title, items }) => (
        <div className="upsells__group" key={`weight-${weight}`}>
          <div className="upsells__group-title">{title}</div>
          {take(items, 2).map(renderProduct)}
        </div>
      ))}
      <div className="upsells__link m-top-8" onClick={() => onShowMore(true)}>
        {get(translation, "UPSELLS.SHOW_MORE", "")}
      </div>
    </div>
  );
};

export default Card;
